import React from "react";

import Ribbon from "../Ribbon";
import Button from "../Button";
import webRootContext from "../../components/webrootcontext/WebRootContext";

function NotFound() {
   
  // you need update the link href
  function return2home(e) {

    // you need update the link href
    window.location.href = webRootContext;
  }

  return (
    <div>
      <div className="div_1_col">
        <Ribbon
          label={"ERROR 404"}
          status={"error"}
          subheader={""}
          content={[
            <span className="error-message--large">
              Sorry, we could not find this page.
            </span>,
            <br />,
            "It may have been deleted or renamed.",
            <br />,
            <br />,
            "Suggestions:",
            <br />,
            <div class="first-level">
              Double-check the URL address and try again
            </div>,
            <div class="first-level">
              Report this issue to &nbsp;
              <a href="mailto:HelpDesk@childrens.harvard.edu">
                HelpDesk@childrens.harvard.edu
              </a>
            </div>,
            // <br />,
            // // you need update the link href
            // <a
            //   className="button button--primary button-link"
            //   type="button"
            //   href="/"
            // >
            //   return to home
            // </a>,
            <br />,
            <Button
              text={"return to home"}
              styleName={"button button--primary"}
              id={"button_return_to_home"}
              type="submit"
              // you need update the link href
              onClick={(e) => return2home(e)}
            ></Button>
          ]}
        />
      </div>
    </div>
  );
}

export default NotFound;
